export default __webpack_public_path__ + "static/media/coton.3750835a.png";